module.exports = __webpack_public_path__ + "static/LocationTokyo-a9b95c1c31509c58cfa73866312da907.jpg";